import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sparkles-svg',
  templateUrl: './sparkles-svg.component.html',
  styleUrls: ['./sparkles-svg.component.scss']
})
export class SparklesSvgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
